import {z} from '@hono/zod-openapi';

/**
 * Decoded vehicle data, or `null` when there is nothing to decode — no VIN, already decoded, or
 * the decoder found no make.
 */
export const priceReportVinDetailsResponseSchema = z
  .object({})
  .passthrough()
  .nullable()
  .openapi('PriceReportVinDetailsResponse');
